module.exports = __webpack_public_path__ + "static/rodrigo-queiroz-adf1b80b0a0072f452d54430d8b02857.jpg";